(()=>{
  const root=document.querySelector('[data-country-flags]');
  if(!root)return;
  const input=root.querySelector('[data-cfd-filter]');
  const empty=root.querySelector('[data-cfd-empty]');
  const cards=[...root.querySelectorAll('[data-flag-name]')];
  const groups=[...root.querySelectorAll('.cfd__group')];
  const letterLinks=[...root.querySelectorAll('.cfd__letters a')];

  cards.forEach((card)=>{
    const image=card.querySelector('img');
    const name=card.dataset.flagName||'';
    if(image&&name)image.alt=`${name} flag`;
  });

  if(!input)return;

  const filter=()=>{
    const query=input.value.trim().toLowerCase();
    let visible=0;
    cards.forEach((card)=>{
      const name=(card.dataset.flagName||'').toLowerCase();
      const code=(card.dataset.flagCode||'').toLowerCase();
      const match=!query||name.includes(query)||code.includes(query);
      card.hidden=!match;
      if(match)visible+=1;
    });
    groups.forEach((group)=>{
      group.hidden=![...group.querySelectorAll('[data-flag-name]')].some((card)=>!card.hidden);
    });
    letterLinks.forEach((link)=>{
      const id=link.getAttribute('href')?.replace('#','');
      const group=id?root.querySelector(`#${CSS.escape(id)}`):null;
      link.hidden=Boolean(group?.hidden);
    });
    if(empty)empty.hidden=visible>0;
  };

  input.addEventListener('input',filter);
})();
